import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OfflineConnectivityService } from './offline-connectivity.service';

// Shared with app.component.ts, which uses this same list to show a blocking overlay when
// connectivity drops while the user is ALREADY on one of these pages (this guard only fires
// on navigation — it can't react to a live connectivity change on a page already open).
// Keep in sync with the canActivate entries in app-routing.module.ts's assessment section.
export const ASSESSMENT_ROUTE_PATHS = [
  'assessmentconsole',
  'assessmentdetails',
  'addquestion',
  'newassessment',
  'studentassesment',
  'editassessment',
  'assessmentsubmissions',
  'allassessments',
  'scoreassessment',
  'assessmentmarksheet',
  'studentassessments',
];

// Assessments are never cacheable (D3 in docs/offline-mode-plan.md: no offline writes of any
// kind, deliberately avoiding the offline-assessment cheating surface) — none of the
// assessment routes are in OFFLINE_ROUTE_ALLOWLIST, so they'd otherwise just fail
// unpredictably offline rather than being blocked with a clear message. Applies regardless
// of whether the offline-mode feature flag is on for this school — this is a general "you
// need a live connection for this" rule, not tied to offline content saving. Registered as
// canActivate on every assessment-prefixed route (app-routing.module.ts).
@Injectable({
  providedIn: 'root',
})
export class OfflineBlockAssessmentGuard {
  constructor(private connectivity: OfflineConnectivityService, private toastr: ToastrService, private router: Router) {}

  canActivate(): boolean {
    if (this.connectivity.currentState === 'online') return true;

    this.toastr.error('Assessments need an internet connection. Please reconnect and try again.', 'Offline');
    this.router.navigate(['/user/dashboard']);
    return false;
  }
}
